import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/vueInit.js";
import store from './store.js'
import '../public/public.css'
import effect from '../public/effect'
Vue.config.productionTip = false 
// axios 
let { post, get } = require("./axios.js")
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.effect = effect;

// 路由守卫 
// router.beforeEach((to, form, next) => {
//   //如果进入到的路由是登录页，则正常展示
//   if (to.path == '/Login') {
//     next();
//   } else if (!localStorage.getItem('userName') || !localStorage.getItem('passWord')) {
//     next('/Login');
//     //转入login登录页面，登录成功后会将token存入localStorage
//   } else {
//     next();
//   }
// })


router.beforeEach((to, from, next) => {
  // 路由跳转后，让页面回到顶部
  // chrome
  document.body.scrollTop = 0; // firefox
  document.documentElement.scrollTop = 0; // safari
  window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
  //to 即将进入的路由
  //from 即将离开的路由
  //next 放行
})


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
